/**
 * On PDP, auto-select a color on page load and commit the first available size.
 * Color priority: URL variant → available sale color → sale color → available color → not fully sold out → first.
 */
(function () {
  const isPdpVariantRadios = (el) =>
    el?.tagName === "VARIANT-RADIOS" &&
    !el.closest("quick-add-modal") &&
    Boolean(el.closest('[id^="MainProduct-"], .main-product'));

  const getColorFieldset = (variantRadios) =>
    variantRadios.querySelector(".product-form__controls--colors") ||
    variantRadios.querySelector("fieldset .variant-image-grid")?.closest("fieldset");

  const getVariantData = (variantRadios) => {
    const jsonEl = variantRadios.querySelector('[type="application/json"]');
    if (!jsonEl) return [];
    try {
      return JSON.parse(jsonEl.textContent);
    } catch {
      return [];
    }
  };

  const getUrlVariant = (variants) => {
    const variantId = new URLSearchParams(window.location.search).get("variant");
    if (!variantId) return null;
    return variants.find((variant) => String(variant.id) === variantId) || null;
  };

  const isVariantOnSale = (variant) =>
    variant &&
    variant.compare_at_price != null &&
    Number(variant.compare_at_price) > Number(variant.price);

  const colorHasAvailableVariant = (colorValue, variants) =>
    variants.some((variant) => variant.option1 === colorValue && variant.available);

  const colorHasAvailableSaleVariant = (colorValue, variants) =>
    variants.some(
      (variant) => variant.option1 === colorValue && variant.available && isVariantOnSale(variant)
    );

  const colorHasSaleVariant = (colorValue, variants) =>
    variants.some((variant) => variant.option1 === colorValue && isVariantOnSale(variant));

  const findColorInput = (variantRadios, colorFieldset) => {
    const variants = getVariantData(variantRadios);
    const colorInputs = [
      ...colorFieldset.querySelectorAll('input[type="radio"][data-option-type="color"]'),
    ];
    if (!colorInputs.length) return null;

    const urlVariant = getUrlVariant(variants);
    if (urlVariant) {
      const urlColorInput = colorInputs.find((input) => input.value === urlVariant.option1);
      if (urlColorInput) return urlColorInput;
    }

    const firstAvailableSaleColor = colorInputs.find((input) =>
      colorHasAvailableSaleVariant(input.value, variants)
    );
    if (firstAvailableSaleColor) return firstAvailableSaleColor;

    const firstSaleColor = colorInputs.find((input) =>
      colorHasSaleVariant(input.value, variants)
    );
    if (firstSaleColor) return firstSaleColor;

    const firstAvailableColor = colorInputs.find((input) =>
      colorHasAvailableVariant(input.value, variants)
    );
    if (firstAvailableColor) return firstAvailableColor;

    return (
      colorInputs.find((input) => input.dataset.fullySoldOut !== "true") ||
      colorInputs[0] ||
      null
    );
  };

  const initVariantRadios = (variantRadios) => {
    if (variantRadios.dataset.pdpColorInit === "true") return;

    const colorFieldset = getColorFieldset(variantRadios);
    if (!colorFieldset) return;
    if (colorFieldset.querySelector('input[type="radio"]:checked')) return;

    const colorInput = findColorInput(variantRadios, colorFieldset);
    if (!colorInput) return;

    colorInput.checked = true;
    colorInput.dispatchEvent(new Event("change", { bubbles: true }));

    if (typeof variantRadios.updateColorNameLabel === "function") {
      variantRadios.updateColorNameLabel();
    }

    if (typeof variantRadios.selectFirstAvailableSizeForColor === "function") {
      variantRadios.selectFirstAvailableSizeForColor();
    }

    variantRadios.dataset.pdpColorInit = "true";
  };

  const run = (root = document) => {
    root.querySelectorAll("variant-radios").forEach((variantRadios) => {
      if (isPdpVariantRadios(variantRadios)) {
        initVariantRadios(variantRadios);
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => run());
  } else {
    run();
  }

  document.addEventListener("shopify:section:load", (event) => {
    run(event.target);
  });
})();
